import React, { useEffect } from 'react'
import {
  DashboardContentContainer,
  Section,
  DashboardEmptyContainer,
  Title,
  UrineCultureContent,
  LeftContainer,
  RightContainer
} from './styles'
import { UrinalysisContent } from '../UrinalysisContent'
import { Antibiogram } from '../Antibiogram'
import { BetaHCG } from '../BetaHCG'
import { Antibiotics } from '../Antibiotics'
import { CompareUrineCulture } from '../CompareUrineCulture'
import { message } from '~/services'
import { UrineCultureList } from '~/components/laboratoryMedicalView'
import { IconComponent } from '~/assets/icons/component'
import { useLaboratoryHealthProcedures, usePatient } from '~/context'

export const Content = (): JSX.Element => {
  const { patient } = usePatient()
  const {
    displayedUrineCulture,
    isLoading,
    getHealthProcedures,
    openModalCompareUrineCulture,
    setOpenModalCompareUrineCulture
  } = useLaboratoryHealthProcedures()

  useEffect(() => {
    getHealthProcedures({ pathParams: { patientId: patient.id } })
  }, [patient.id, getHealthProcedures])

  const hasData = (): boolean => {
    const hasHealthProcedures = !!(displayedUrineCulture && displayedUrineCulture.length > 0)
    return hasHealthProcedures
  }

  return (
    <>
      {hasData() || isLoading ? (
        <DashboardContentContainer>
          <Section>
            <Title>{message('laboratory.urine_culture')}</Title>
            <UrineCultureList />
          </Section>
          <UrineCultureContent>
            <LeftContainer>
              <UrinalysisContent />
              <BetaHCG />
            </LeftContainer>
            <RightContainer>
              <Antibiogram />
              <Antibiotics />
            </RightContainer>
          </UrineCultureContent>
        </DashboardContentContainer>
      ) : (
        <DashboardEmptyContainer>
          <IconComponent name="notFound" />
          <h1>{message('laboratory.not_found')}</h1>
        </DashboardEmptyContainer>
      )}
      <CompareUrineCulture showModal={openModalCompareUrineCulture} setShowModal={setOpenModalCompareUrineCulture} />
    </>
  )
}
